const menuMaxWidth = '400px'

export default () =>
  ({
    menuWidthHelper: {
      maxWidth: menuMaxWidth,
    },
  }) as const
